import { PageModel } from "./PageModel";

class HomePageModel extends PageModel {

}

export {HomePageModel}